export default {
  strict: true,
  namespaced: true,
  state: {
    upcoming: [],
    history: [],
    isMax: {
      upcoming: false,
      history: false
    },
    currentPage: {
      upcoming: 0,
      history: 0
    },
    fromTo: {
      upcomingTo: '',
      upcomingFrom: '',
      historyTo: '',
      historyFrom: ''
    },
    totalDriverPayment: {
      upcoming: {
        total: 0,
        loading: false
      },
      history: {
        total: 0,
        loading: false
      }
    },
    breakdown: {
      upcoming: [],
      history: [],
      deductions: []
    },
    rsvpPerPage: 20
  },
  mutations: {
    resetRsvp (state, value) { state[value] = [] },
    addRsvp (state, value) { state[value.type].push(value.rsvp) },
    setCurrentPage (state, value) { state.currentPage[value.type] = value.page },
    setIsMax (state, value) { state.isMax[value.type] = value.isMax },
    setFromTo (state, value) {
      state.fromTo[value.type + 'From'] = value.from
      state.fromTo[value.type + 'To'] = value.to
    },
    setTotalDriverPayment (state, data) { state.totalDriverPayment[data.type].total = data.value },
    setTotalDriverPaymentLoading (state, data) { state.totalDriverPayment[data.type].loading = data.value },
    setProviderBreakdown (state, data) { state.breakdown[data.type] = data.value },
    addProviderBreakdown (state, data) { state.breakdown[data.type].push(data.value) }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/provider/reservations.js